import { atom } from "recoil";

export const clientTypesState = atom({
  key: "clientTypesState",
  default: [],
});
